import * as React from 'react';
import MAutoComplete from '../../../components/controls/MAutoComplete';

/** Options accepted by {@link MAutoComplete}, minus the ones {@link TagsAutoComplete} sets itself. */
type IMAutoCompleteProps = React.ComponentProps<typeof MAutoComplete>;

const getStyles = (tagName: string) => {
    switch (tagName) {
        case 'venue removal':
            return 'royalblue';
        case 'pricing error':
            return 'limegreen';
        case 'listing error':
            return 'gold';
        case 'banned':
            return 'coral';
        default:
            return '';
    }
};

/** Props for {@link TagsAutoComplete}. */
export interface ITagsAutoCompleteProps extends Omit<IMAutoCompleteProps, 'choices' | 'getStyles' | 'name'> {
    /** Called with the newly selected tag values. */
    onChange: IMAutoCompleteProps['onChange'];
}

/**
 * Autocomplete for the fixed set of CSV Merge tags, color-coded via
 * {@link getStyles}. Forwards any extra props to `MAutoComplete`.
 */
const TagsAutoComplete: React.FC<ITagsAutoCompleteProps> = ({ onChange, ...props }) => {
    return (
        <MAutoComplete {...props}
            name="tags"
            onChange={onChange}
            choices={['Venue removal', 'Pricing error', 'Listing error', 'Banned', 'Markup']}
            getStyles={getStyles}
        />
    );
};

export default TagsAutoComplete;
